export function beforeSave(record) {
  const newRecord = [...record];
  return newRecord.map((address) => ({
    ...address,
    label: address.label.id,
  }));
}
